export enum CodeMirrorTheme {
  Default = 'default',
  Material = 'material',
  Darcula = 'darcula',
}
